import { render, staticRenderFns } from "./SegmentResultCard.vue?vue&type=template&id=24671827&scoped=true"
import script from "./SegmentResultCard.vue?vue&type=script&lang=js"
export * from "./SegmentResultCard.vue?vue&type=script&lang=js"
import style0 from "./SegmentResultCard.vue?vue&type=style&index=0&id=24671827&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24671827",
  null
  
)

export default component.exports